const EventReferrers = {
  PARAMETER_NAME: 'eventreferrer',
  Events: {
    DAY_ZERO_POST_AUTO_BOUND: 'DAY_ZERO_POST_AUTO_BOUND',
  },
};

export default EventReferrers;
